<template>
  <li class="views-list-item"
      :class="itemStyles">
    <div class="video-thumbnail">
      <img class="thumbnail" :src="thumbnailUrl" />
    </div>

    <div class="view-info">
      <div class="video-name">
        <div class="name">
          {{ item.video_data.title }}
        </div>

        <div class="runtime">
          {{ $t("tabs.youtube.runtime") }}: {{ item.video_data.runtime | durationTime }}
        </div>

        <a class="link" :href="videoUrl">
          {{ videoUrl }}
        </a>
      </div>

      <div class="device-name">
        <div>{{ device ? device.name : '' }}</div>
      </div>

      <div v-if="isToday(item.video_data.begin_time)" class="time">
        {{ item.video_data.begin_time | timeAgo }}
      </div>

      <div class="time">
        {{ item.video_data.begin_time | localTime }}
      </div>
    </div>
  </li>
</template>

<script>
  import { isToday } from '@/services/intl'

  export default {
    props: {
      item: {
        required: true,
        type: Object
      }
    },

    methods: {
      isToday
    },

    computed: {
      itemStyles() {
        return {
          'views-list-item-mobile': this.$mq === 'mobile'
        }
      },

      thumbnailUrl() {
        return `https://img.youtube.com/vi/${this.item.video_data.video_id}/1.jpg`
      },

      videoUrl() {
        return `https://www.youtube.com/watch?v=${this.item.video_data.video_id}`
      },

      child() {
        return this.getChildById(this.item.user_id)
      },

      device() {
        return this.child.devices.find(device => device.id === this.item.device_id)
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),
    }
  }
</script>

<style lang="scss" scoped>
  .views-list-item {
    display: flex;
    align-items: center;

    padding: 15px 0;
    min-height: 64px;
    border-top: 1px solid #f2f2f2;

    .video-thumbnail {
      display: flex;
      align-items: center;
      justify-content: center;

      margin: 0;
      padding: 0;
      margin-right: 20px;
    }

    .view-info {
      display: flex;
      align-items: center;
      width: 100%;

      .video-name {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        flex: 2 0;

        .name {
          color: map.get($colors, primary);
          margin-bottom: 10px;
        }

        .runtime, .link {
          font-size: 14px;
          color: rgba(#3e3a3b, .7);
        }
      }

      .device-name, .time {
        flex: 1 0;
        text-align: right;
        color: rgba(#3e3a3b, .7);
      }
    }

    &:last-child {
      border-bottom: 1px solid #f2f2f2;
    }
  }

  .views-list-item-mobile {
    .video-thumbnail {
      .thumbnail {
        width: 60px;
        height: 40px;
      }
    }

    .view-info {
      flex-wrap: wrap;

      .video-name {
        width: 100%;
        flex: unset;

        .name {
          font-size: 14px;
          margin-bottom: 5px;
        }

        .runtime, .link {
          font-size: 12px;
        }
      }

      .device-name {
        margin-right: 20px;
      }

      .device-name, .time {
        flex: unset;
        font-size: 12px;
        padding-top: 5px;
      }
    }
  }
</style>
